import {isNumber} from "@pg-mono/nodash";

import {ISlugParsed} from "../helpers/friendly_offer_list/offer_url_parser";
import {ISearchAPIResponse} from "../types/ISearchAPIResponse";

export const mapSearchToSearchQuery = (search: ISearchAPIResponse, priceLowerThanAverage?: boolean): Partial<ISlugParsed> => {
    const result: Partial<ISlugParsed> = {};
    // type & region
    if (isNumber(search.type)) {
        result.type = search.type;
    }
    if (isNumber(search.region)) {
        result.region = [search.region.toString()];
    }
    if (search.country) {
        result.country = search.country;
    }
    if (search.region_name) {
        result.region_name = search.region_name;
    }

    // price
    if (search.price && search.price.lower) {
        result.price_0 = search.price.lower;
    }
    if (search.price && search.price.upper) {
        result.price_1 = search.price.upper;
    }

    // rooms
    if (search.rooms && search.rooms.lower) {
        result.rooms_0 = search.rooms.lower;
    }
    if (search.rooms && search.rooms.upper) {
        if (search.rooms.lower === 5) {
            // equal-rooms guard like in legacy code
            result.rooms_1 = undefined;
        } else {
            result.rooms_1 = search.rooms.upper;
        }
    }

    // area
    if (search.area && search.area.lower) {
        result.area_0 = search.area.lower;
    }
    if (search.area && search.area.upper) {
        result.area_1 = search.area.upper;
    }

    // sort
    if (search.sort) {
        result.sort = search.sort;
    }

    // additional
    if (search.is_luxury) {
        result.is_luxury = search.is_luxury;
    }

    // price_lower_than_average does not appear in search and is used in SEO context for "tanie..." listings
    if (priceLowerThanAverage) {
        result.price_lower_than_average = priceLowerThanAverage;
    }

    return result;
};
